// extracted by extract-css-chunks-webpack-plugin
module.exports = {"card":"_1BCr9","cardTitle":"_1oRjY","cardItem":"_2ErIK","cardItemTitle":"_1FqUP","cardItemValue":"iSe9f"};